import { SET_BASKET, SET_BASKET_ERROR, SET_BASKET_SUCCESS } from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import store from "core-web/state/store";

export const setBasketId = (basketId) => (dispatch) => {
    dispatch({ type: SET_BASKET });
    try {
        dispatch({
            type: SET_BASKET_SUCCESS,
            basketId,
        });

        Events.trigger(BasketEvents.SET);
        return true;
    } catch (e) {
        dispatch({ type: SET_BASKET_ERROR });
        throw e;
    }
};

export default (basketId) => store.dispatch(setBasketId(basketId));
